<div class="video-annotation-container">
  <div
    class="d-flex align-items-center justify-content-center flex-column position-relative video-player video-js-element-width-track"
    [ngClass]="{ 'annotation-active': enableVideoAnnotation, 'drawing-hidden': !canAddAnnotationComment }"
    [class.fullscreen]="isFullscreen">
    <video
      id="videoJsEl"
      class="video-js m-0 video-js-element-container video-js-element-container--without-comment-bar"
      controls
      #videoPlayer
      [class.release-preview]="isReleasePreview"
      [class.share-link-preview]="isShareLinkPreview"></video>
    @if (previewSubtitle) {
      <div class="vjs-text-track-display">
        <div style="position: absolute; inset: 0px; margin: 1.5%">
          <div
            class="vjs-text-track-cue vjs-text-track-cue-en"
            lang="en"
            style="
              direction: ltr;
              writing-mode: horizontal-tb;
              unicode-bidi: plaintext;
              text-align: center;
              font: 17.32px sans-serif;
              white-space: pre-line;
              position: absolute;
              width: 620.8px;
              inset: 325.4px 0px 0px;
              height: 21px;
              background-color: rgba(0, 0, 0, 0);
            ">
            <div
              style="
                color: rgb(255, 255, 255);
                background-color: rgb(0, 0, 0);
                position: relative;
                inset: 0px;
                display: inline;
                writing-mode: horizontal-tb;
                unicode-bidi: plaintext;
                font-family: sans-serif;
              ">
              The quick brown fox jumps over the lazy dog
            </div>
          </div>
        </div>
      </div>
    }

    @if (isPlayerReady) {
      <div #playButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-play-button [playing]="isPlaying" (togglePlay)="togglePlay()"></viewer-play-button>
      </div>
      <div #volumeButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-volume-button
          [muted]="isMuted"
          [volume]="currentVolume"
          (toggleMute)="toggleMute()"
          (volumeChange)="onVolumeChange($event)"></viewer-volume-button>
      </div>
      <div #timeDisplayWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected vjs-control-bar-time-display">
        <viewer-time-display
          [currentTime]="currentTime"
          [duration]="duration"
          [frameRate]="frameRate"
          [isFullscreen]="isVideoFullscreen"></viewer-time-display>
      </div>
      <div #settingsButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-settings-button
          [item]="item"
          [instanceId]="instanceId"
          [resolution]="currentResolution()"
          [playbackRate]="currentPlaybackRate()"
          [isFullscreen]="isVideoFullscreen"
          (resolutionChange)="onResolutionChange($event)"
          (playbackRateChange)="onPlaybackRateChange($event)"></viewer-settings-button>
      </div>
      <div
        #cinemaModeButtonWrapper
        class="vjs-custom-button-wrapper vjs-hidden-until-injected vjs-hide-when-control-bar-overflow">
        <viewer-cinema-mode-button
          [active]="cinemaMode"
          [isFullscreen]="isVideoFullscreen"
          (exitFullscreenRequest)="onCinemaModeExitFullscreen()"></viewer-cinema-mode-button>
      </div>
      <div #rejectButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-reject-button></viewer-reject-button>
      </div>
      <div #approveButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-approve-button></viewer-approve-button>
      </div>
      <div #compareButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-compare-button
          [projectId]="projectId || item?.projectId"
          [sectionId]="sectionId || item?.sectionId"
          [subsectionId]="subsectionId || item?.subSectionId"
          [optionId]="typeId || item?.optionId || item?.itemId"
          [versionNumber]="item?.versionNumber"
          [isFullscreen]="isVideoFullscreen"
          [fileId]="item?.id"></viewer-compare-button>
      </div>
      <div
        #downloadButtonWrapper
        class="vjs-custom-button-wrapper vjs-hidden-until-injected vjs-hide-when-control-bar-overflow">
        <mtm-file-download-control
          [file]="item"
          displayType="icon"
          [iconSize]="18"
          [lightIcon]="true"
          [iconColor]="'#b0b0b0'"
          [isFullscreen]="isVideoFullscreen"
          [uniqueControlId]="`video-js-${instanceId}-${item?.id}`">
        </mtm-file-download-control>
      </div>
      <div #infoButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-info-button [file]="item" [useFixedPosition]="true"></viewer-info-button>
      </div>
      <div #annotationToggleButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected">
        <viewer-annotation-toggle-button
          [isActive]="!isAnnotationDisplayEnabled"
          (clicked)="toggleAnnotationDisplay()"></viewer-annotation-toggle-button>
      </div>
      <div
        #fullscreenButtonWrapper
        class="vjs-custom-button-wrapper vjs-hidden-until-injected vjs-hide-when-control-bar-overflow">
        <viewer-fullscreen-button
          [active]="isFullscreen"
          (clicked)="toggleFullscreenForViewer()"></viewer-fullscreen-button>
      </div>
      <div #moreButtonWrapper class="vjs-custom-button-wrapper vjs-hidden-until-injected vjs-control-more-dropdown">
        <div ngbDropdown class="control-bar-more-dropdown" container="body" placement="top">
          <button
            type="button"
            class="viewer-controller-icon-btn control-bar-more-toggle"
            ngbDropdownToggle
            aria-haspopup="true"
            [attr.aria-label]="'More' | translate">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <circle cx="8" cy="3" r="1.25" fill="currentColor" />
              <circle cx="8" cy="8" r="1.25" fill="currentColor" />
              <circle cx="8" cy="13" r="1.25" fill="currentColor" />
            </svg>
          </button>
          <div ngbDropdownMenu class="control-bar-more-menu">
            <div class="control-bar-more-menu-inner">
              <mtm-file-download-control
                [file]="item"
                displayType="icon"
                [iconSize]="18"
                [lightIcon]="true"
                [iconColor]="'#b0b0b0'"
                [uniqueControlId]="`video-js-more-${instanceId}-${item?.id}`">
              </mtm-file-download-control>
              <viewer-cinema-mode-button
                [active]="cinemaMode"
                [isFullscreen]="isVideoFullscreen"></viewer-cinema-mode-button>
              <viewer-fullscreen-button
                [active]="isFullscreen"
                (clicked)="toggleFullscreenForViewer()"></viewer-fullscreen-button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (enableVideoAnnotation && isPlayerReady) {
      <div class="marker-container w-100" [ngClass]="{ disabled: !isAnnotationDisplayEnabled }">
        <div class="d-block annotation-bar-container mx-auto mt-auto w-100">
          <mtm-videojs-annotation-bar-list
            [annotations]="annotations"
            [player]="player"
            [projectId]="projectId"
            [sectionId]="sectionId"
            [subsectionId]="subsectionId"
            [projectParticipants]="projectParticipants"
            [typeId]="typeId"
            [item]="item"
            [annotationPlugin]="annotationPlugin"
            [isPlayerReady]="isPlayerReady"
            [isVideo]="true"
            [instanceId]="instanceId"
            [progressBarClickedTime]="progressBarClickedTime">
          </mtm-videojs-annotation-bar-list>
        </div>
      </div>
    }
  </div>
</div>
